import { stat } from 'fs';
import {

    GET_GLOBAL_REASSIGN_DEVICE_REQUEST,
    GET_GLOBAL_REASSIGN_DEVICE_SUCCESS,
    GET_GLOBAL_REASSIGN_DEVICE_FAILURE,

    ADD_PREVIEW_REASSIGN_DEVICE,
    REMOVE_PREVIEW_REASSIGN_DEVICE,

} from '../constants/';

const INIT_STATE = {
    isLoading: false,
    isInitialFetch: true,
    error: null,
    devices: [],
    previewDevices: [],
    accountId: null,
    accounts: [],
    message: undefined,
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case GET_GLOBAL_REASSIGN_DEVICE_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_GLOBAL_REASSIGN_DEVICE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                devices: action.payload.devices,
                isInitialFetch: false,
            };
        case GET_GLOBAL_REASSIGN_DEVICE_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error.stack,
            };

        case ADD_PREVIEW_REASSIGN_DEVICE:
            return {
                ...state,
                previewDevices: action.payload.devices
            };

        case REMOVE_PREVIEW_REASSIGN_DEVICE:
            return {
                ...state,
                previewDevices: []
            };

        default:
            return state;
    }
};